"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabCarouselItem;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const TabCarouselItemContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TabCarouselItemContainer",
  class: "pl-t1vuuhq4",
  vars: {
    "t1vuuhq4-1": [({
      active
    }) => active ? 'auto' : '0'],
    "t1vuuhq4-2": [({
      active
    }) => active ? 'translateX(0)' : 'translateX(200%)'],
    "t1vuuhq4-3": [({
      active
    }) => active ? 'transform 1s ease-in-out' : 'initial'],
    "t1vuuhq4-4": [({
      active
    }) => active ? '1' : '0'],
    "t1vuuhq4-5": [({
      active
    }) => active ? '100' : '0']
  }
});

/**
 * TabCarouselItem Component
 *
 * @param {object} props React props
 * @param {string} props.id Id
 * @param {node} props.content Tab's content
 * @param {boolean} props.active True if active tab, otherwise false
 * @param {boolean} props.slideAnimation True to use slide animation, false to use fade in
 * @returns {React.ReactElement} TabCarouselItem Component
 * @public
 */
function TabCarouselItem({
  id,
  active,
  content,
  slideAnimation = true
}) {
  return /*#__PURE__*/_react.default.createElement(TabCarouselItemContainer, {
    id: id,
    active: active,
    "data-animation": slideAnimation ? 'slide' : 'fade-in',
    "data-cy": "tab-carousel-item"
  }, content);
}
TabCarouselItem.propTypes = {
  id: _propTypes.default.string,
  tabTitle: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  content: _propTypes.default.node,
  active: _propTypes.default.bool,
  slideAnimation: _propTypes.default.bool
};